import { useRecoilValue } from 'recoil';
import { usePrevious } from 'react-delta';

import { currentResultsTabState } from 'components/common/Managers/ViewStateManager.state';

export const useDidResultsTabChange = () => {
  const resultsTab = useRecoilValue(currentResultsTabState);
  const prevResultsTab = usePrevious(resultsTab);

  return {
    didResultsTabChange: Boolean(prevResultsTab?.id && prevResultsTab.id !== resultsTab?.id),
    isNewResultsTab: prevResultsTab?.id !== resultsTab?.id,
  };
};
